import { render, staticRenderFns } from "./AuthImg.vue?vue&type=template&id=994a49c0&"
import script from "./AuthImg.vue?vue&type=script&lang=js&"
export * from "./AuthImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports